import React from 'react';
import './TextInput.scss';
import PropTypes from 'prop-types';

export default function TextInput(props) {
  const {
    type,
    value,
    valueChange,
    placeholder,
    visible,
    className,
    register,
  } = props;

  return (
    <div className={`input-container ${className} ${!visible && 'hidden'}`}>
      <input
        {...register}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          valueChange(e.target.value);
          if (register && register.onChange) register.onChange(e);
        }}
        onKeyDown={(e) => e.key === 'Enter' && e.target.blur()}

      />
    </div>
  );
}

TextInput.defaultProps = {
  type: 'text',
  value: undefined,
  valueChange: () => {},
  placeholder: '',
  visible: true,
  className: '',
  register: {},
};

TextInput.propTypes = {
  type: PropTypes.string,
  value: PropTypes.string,
  valueChange: PropTypes.func,
  placeholder: PropTypes.string,
  visible: PropTypes.bool,
  className: PropTypes.string,
  register: PropTypes.shape(),
};
